import React from 'react';
import styles from './Quiz.module.css';
import { AnimatePresence, motion } from 'framer-motion';
import Question from '../Question/Question';
import VarItem from '../VarItem/VarItem';
import VarItemCorrect from '../VarItemCorrect/VarItemCorrect';
import classNames from 'classnames';
import { useImgOrientation } from '../../hooks/useImgOrientation';

const Quiz = ({
  className,
  variants,
  title,
  questionImgUrl,
  currentState,
  questionFontSize,
  answerFontSize,
  varNumFontSize,
}) => {
  const { orientation } = useImgOrientation(questionImgUrl);

  const isLong = title?.length > 170;
  let count = 0;

  if (!orientation) {
    return null;
  }

  return (
    <div
      className={classNames(className, styles.containerQuize, {
        [styles.containerQuize_large]: !questionImgUrl && variants.length <= 1,
      })}>
      <div
        className={classNames(styles.question_large, {
          [styles.hidden]: variants.length > 1,
        })}>
        <Question
          title={title}
          questionImgUrl={questionImgUrl}
          isLong={isLong}
          questionFontSize={questionFontSize}
        />
      </div>

      <AnimatePresence>
        {variants.length <= 1 && currentState === 'S5' ? (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1, delay: 0 }}
            className={styles.winner}>
            <VarItemCorrect
              item={variants.find((el) => el.correct)}
              withoutNum
              answerFontSize={answerFontSize}
              varNumFontSize={varNumFontSize}
              isQuestionImg
            />
          </motion.div>
        ) : null}
      </AnimatePresence>

      <div
        className={questionImgUrl ? styles.blockQuiz : styles.blockQuizNoImg}
        key={questionImgUrl}>
        {questionImgUrl && (
          <motion.div
            initial={{
              opacity: 0,
              y: '100vh',
            }}
            animate={{
              opacity: 1,
              y: '0',
            }}
            transition={{ duration: 0.5, delay: 0 }}
            className={styles.blockImgQuestion}>
            <img
              src={questionImgUrl}
              alt=""
              className={classNames(styles.questionImg, {
                [styles.onlyAnswer]: variants.length <= 1,
                [styles.horizontal]: orientation === 'horizontal',
              })}
            />
          </motion.div>
        )}

        <div
          style={{ display: variants.length > 1 ? 'flex' : 'none' }}
          className={classNames(styles['vars-wrapper'], {
            [styles.hidden]: currentState === 'S4' && variants.length <= 1,
            [styles.onlyAnswer]:
              !questionImgUrl && currentState === 'S5' && variants.length <= 1,
          })}>
          <Question
            title={title}
            large={!questionImgUrl && variants.length <= 1}
            questionImgUrl={questionImgUrl}
            isLong={isLong}
            questionFontSize={questionFontSize}
          />
          <div
            className={classNames(styles.vars, {
              [styles.correct]:
                !questionImgUrl &&
                variants.length <= 1 &&
                currentState === 'S5',
            })}>
            {variants?.map((item, i) => {
              if (item.comment.length > 36 && !item.correct) {
                // 36 символов в одной строке
                count++;
              }
              return (
                <motion.div
                  key={item.id}
                  style={{ display: 'flex', alignItems: 'center' }}>
                  <div className={styles.varRight}>
                    <>
                      {currentState === 'S5' || !currentState ? (
                        item.correct ? (
                          <VarItemCorrect
                            item={item}
                            i={i}
                            withoutNum={variants.length <= 1}
                            answerFontSize={answerFontSize}
                            varNumFontSize={varNumFontSize}
                            isQuestionImg
                          />
                        ) : (
                          <VarItem
                            item={item}
                            i={i}
                            answerFontSize={answerFontSize}
                            varNumFontSize={varNumFontSize}
                            isQuestionImg
                          />
                        )
                      ) : (
                        variants.length > 1 && (
                          <VarItem
                            item={item}
                            i={i}
                            answerFontSize={answerFontSize}
                            varNumFontSize={varNumFontSize}
                            isQuestionImg
                          />
                        )
                      )}
                    </>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Quiz);
